export default "__VITE_ASSET__cMU6C4aZ__"